import { OVERLAY_CONTAINER_PROVIDER_FACTORY } from '@angular/cdk/overlay/overlay-container';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StringDecoder } from 'string_decoder';
import { environment } from '../../environments/environment';
import { AsignacionProyecto,Estatus, Iniciativa, UsuarioAutorizado, Usuario,UsuarioEstatus, Proceso, Procedimiento, PriorizacionArea } from '../interfaces/interfaces';
import { IniciativaDetalle } from '../models/iniciativa';
import { Paginado, PaginadoAdiminstrador, PaginadoLider } from '../models/paginado';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  urlAPI: string;
  private HEADERSjson: HttpHeaders;
  //Url de la API creada por Osva
  urlAPI2:string;

  constructor(private http: HttpClient) {
    // Dependiendo del tipo de deploy apuntar a productivo o a calidad
    //this.urlAPI = environment.UrlApi;
    //URL de la API v2
    this.urlAPI2=environment.UrlApiV2;
  }

   // Método para cambiar la normativa
  cambiarNormativa(obj: any): Observable<any> {
  return this.http.post(`${this.urlAPI2}IniciativaNueva/atencionNormativa`, obj);
  }


  //Insertar usuario V2 API 
  insertarUsuarioV2(user:Usuario)
  {
    let addUser = JSON.stringify(user);  
    return this.http.post(`${this.urlAPI2}users/insertUser`, user);
  }

  //Método para obtener las jefaturas
  obtenerJefaturas(area:number)
  {
    
    return this.http.post(`${this.urlAPI2}jefatura/getJefaturasByDireccion/${area}`,'');
  }

  //Método para obtener los tipos de usuarios
  obtenerTiposUsuariosv2() 
  {
    return this.http.post(`${this.urlAPI2}roles/getActiveRoles`,'');
  }


  //Método para obtener los usuario
  cargarUsuariosAutorizados(pagina:number, user?:string)
  {
     let emailUser={
      email_usuario:user
     }
      return this.http.post(`${this.urlAPI2}users/getUsers/${pagina}`,emailUser);
  }

  cargarUsuariosFiltro(pagina:number, user?:Usuario, filtro?:string)
  {
    user.nombre_usuario=filtro;
    user.email_usuario=filtro;
    user.dep_usuario=filtro;
    user.direccion_areaUsuario=filtro;
    user.puesto_usuario=filtro;
    user.telefono_usuario=filtro;
    user.extension_usuario=filtro;
    return this.http.post(`${this.urlAPI2}users/getUsers/${pagina}`,user);
  }
  //Método para cambiar estatus de usuarios
  cambioEstatus(user:Usuario[])
  {
    //recorremos el arreglo y cambiamos el estatus
    user.forEach(function(item){
      let estatus= item.estatus_usuario== 1 ? 0: 1
      item.estatus_usuario = estatus;
    })

    let addUser = JSON.stringify(user,['email_usuario', 'estatus_usuario']);  
    let json=JSON.parse(addUser);
    return this.http.post(`${this.urlAPI2}users/toggleActiveMultipleUsers`,json);
  }


   //Método para cambiar estatus vip de usuarios
   cambiarEstatusVIP(user:Usuario[])
   {
     //recorremos el arreglo y cambiamos el estatus
     user.forEach(function(item){
       let vip= item.vip_usuario== 1 ? 0: 1
       item.vip_usuario = vip;
     })
     let addUser = JSON.stringify(user,['email_usuario', 'vip_usuario']);  
     let json=JSON.parse(addUser);
     return this.http.post(`${this.urlAPI2}users/toggleVIPMultipleUsers`,json);
   }

  // Periodo de envios
  esPeriodoEnvios(){
    return this.http.post(`${this.urlAPI2}Periodo/periodoEnvio`,'');
  }

  // Iniciativas Datos
  obtenerIniciativasUsuario(paginado: Paginado) 
  {
    return this.http.post(`${this.urlAPI2}IniciativaNueva/getIniciativas`,paginado);
  }

  // Usuarios V1
  obtenerTiposUsuarios() {
    //return this.http.get(`${this.urlAPI}Roles/getAllRoles`);
    return this.http.post(`${this.urlAPI2}roles/getActiveRoles`,'');

  }
  
  //Tabla usuarios
  obtenerInfoUsuario(cuentaUsr: string) 
  {
    let user={
       email_usuario: cuentaUsr
    }
    return this.http.post(`${this.urlAPI2}users/getUserByEmail`,user, { headers: this.HEADERSjson });
  }

  //Tabla usuariosSAP
  buscarPorUsuario(cuentaUsr: string)
  {
    return this.http.post(`${this.urlAPI2}users/getSAPUserByEmail`,cuentaUsr);

  }

  editarUsuario(user: Usuario) 
  {
    return this.http.post(`${this.urlAPI2}users/updateUser`, user);
  }

  /////////////////////////////// Modulo de iniciativas //////////////////////////////////////////
  // Iniciativas Inserciones para la opcion "Nuevo Sistema"
//Método para obtener los tipos de usuarios
obtenerImpactos() 
{
  return this.http.post(`${this.urlAPI2}IniciativaNueva/GetImpatos`,'');
}

  nuevoSistema(data: Iniciativa) 
  {
    return this.http.post(`${this.urlAPI2}IniciativaNueva/insertIniciativa`,data);
  }

  editarNuevoSistema(data: Iniciativa) 
  {
    return this.http.post(`${this.urlAPI2}IniciativaNueva/updateIniciativa`,data);
  }

  //Obtiene la información de una iniciativa por id
  detalleIniciativa(id: number)
  {
    return this.http.post(`${this.urlAPI2}IniciativaNueva/getIniciativaById/${id}`,'');
  }

  //Método para recuperar el form del proceso
  detalleProceso(id_iniciativa: number,id_proceso:number)
  {
    return this.http.post(`${this.urlAPI2}costeo/getCosteo/${id_iniciativa}/${id_proceso}`,'');
  }

  /*Lista para obtener la lista de procesos
  listaProcedimientos(id:number)
  {
    return this.http.post(`${this.urlAPI2}IniciativaNueva/getListDetalleProcesos/${id}`,'');
  }*/


  // Iniciativas Administrador
  obtenerTodasIniciativas(paginado: PaginadoAdiminstrador) 
  {
    return this.http.post(`${this.urlAPI2}IniciativaNueva/getIniciativas`,paginado);
  }
  
  //Método para descargar el archivo excel de la tabla de iniciativas
  descargarArchivoIniciativas(paginado: Paginado)
  {
    return this.http.post(`${this.urlAPI2}IniciativaNueva/descargarExcelIniciativas`,paginado,{ responseType: 'blob' });
  }

  //Iniciativas para priorizar
  obtenerIniciativasPriorizacion(email:string,rol:number,order?:boolean)
  {
    let data={
      'email':email,
      'rolUserlogin':rol,
      'orderByGeneral':order
    }
    return this.http.post(`${this.urlAPI2}IniciativaNueva/getIniciativasPriorizacion`,data);
  }
  //Método para agregar procedimientos
  insertarUpdateListDetalleProceso(detalles:Procedimiento[])
  {
    return this.http.post(`${this.urlAPI2}IniciativaNueva/insertUpdateListDetalleProceso`,detalles);
  }

  //Método para agregar procedimiento
  insertarUpdateProceso(data:Proceso,detalles:Procedimiento[])
  {
    let proceso={
      'proceso':data,
      'listDetalleProcesos':detalles
    }
    return this.http.post(`${this.urlAPI2}costeo/insertUpdateCosteo`,proceso);
  }

  //Método para mostrar el historial de las iniciativas
  historialIniciativa(id_iniciativa:number)
  {
    return this.http.post(`${this.urlAPI2}Historial/getHistorialByIniciativa/${id_iniciativa}`,'');
  }
  //Método para borrar los detalles proceso de la base
  deleteDetalleProcesoByProceso(id_proceso:number)
  {
    return this.http.post(`${this.urlAPI2}IniciativaNueva/deleteDetalleProcesoByProceso/${id_proceso}`,'');
  }

  deleteIniciativa(id_iniciativa:number, email:string,rol:number)
  {
    let data={
      'id_iniciativa':id_iniciativa,
      'email':email,
      'rolUserlogin':rol
    }
    return this.http.post(`${this.urlAPI2}IniciativaNueva/deleteIniciativaById`,data);
  }

  duplicarIniciativa(id_iniciativa:number, email:string, rol:number)
  {
    let data={
      'id_iniciativa':id_iniciativa,
      'email':email,
      'rolUserlogin':rol
    }
    return this.http.post(`${this.urlAPI2}IniciativaNueva/duplicarIniciativa`,data);
  }

  cambiosFuncionalidades(data: Iniciativa) 
  {
    return this.http.post(
      `${this.urlAPI2}IniciativaNueva/insertIniciativa`,data);
  }

  correccionFuncionalidades(data: Iniciativa) {
    return this.http.post(
      `${this.urlAPI}IniciativaNueva/insertIniciativaNueva`,
      data
    );
  }

  //Método para subir archivos
  subirArchivos(archivo: File, nombreArchivo: string, idIniciativa:number) 
  {
    let extencion;
    let ext;
    //Si es archivo
    if(archivo.type)
    {
      ext = archivo.type.split('/');
      switch (archivo.type)
        {
              case "application/zip":
                ext[1]="zip";
                break;
              case "application/pdf":                
              ext[1]="pdf";
              break;
              case "application/x-zip-compressed":
                ext[1]="zip";
              break;
              case "application/octet-stream":
                ext[1]="zip";
              break;
              case "application/x-rar-compressed":
                ext[1]="rar";
              break;
              default:
                break;
            }
      extencion=ext[1];
    }
    //Si es carpeta
    else{
      ext = archivo.name.split('.');
      extencion=ext[ext.length-1];
    }
    const formData: FormData = new FormData();
    formData.append('file', archivo, nombreArchivo+'.'+extencion);
    return this.http.post(`${this.urlAPI2}Archivo/SubirArchivoIniciativa/${idIniciativa}`,formData);
  }

  //Obtener areas
  obtenerGruposSistemas() {
    return this.http.post(
      `${this.urlAPI2}IniciativaNueva/getAreas`,'');
  }

  obtenerAplicativos(idGrupo: number) {
    return this.http.post(
      `${this.urlAPI2}IniciativaNueva/getAplicacionesByArea/${idGrupo}`,'');
  }

  obtenerAreaSolicitante(areaGral: number) {
    /*let valores={
      'nombre_dirgralSap':areaGral
    }*/
   // let valores=parseInt(areaGral);
    return this.http.post(
      `${this.urlAPI2}dirAreaSAP/getListDirAreaByIdDirGeneral/${areaGral}`,'');
  }

  //Método para obtener la direccion general
  obtenerDireccionGral(id_iniciativa:number,user:string) 
  {
    let valores={
      'id_iniciativa':id_iniciativa,
      'userlogin':user
    }
    return this.http.post(`${this.urlAPI2}dirGeneralSAP/getListDireccionGeneralSAP`,valores);
  }

  //Método para descargar el archivo de ejemplo del costeo
  descargarArchivoCosteo()
  {
    return this.http.get(`${this.urlAPI2}Archivo/descargarExcelCosteo`,{ responseType: 'blob' });
  }

  //Método para subir el archivo de costeo
  subirArchivoCosteo(archivo: File,id_iniciativa:number, id_proceso:number)
  {
    const formData: FormData = new FormData();
    formData.append('file', archivo, archivo['name']);
    return this.http.post(`${this.urlAPI2}costeo/cargarExcelCosteo/${id_iniciativa}`,formData)
  }

   //Método para subir el archivo de costeo
   subirArchivoComentarios(archivo: File,id_iniciativa:number, id_comentario:number)
   {
     const formData: FormData = new FormData();
     formData.append('file', archivo, archivo['name']);
     return this.http.post(`${this.urlAPI2}Archivo/subirArchivoComentario/${id_iniciativa}/${id_comentario}`,formData)
   }

  // Descarga de archivos
  descargarArchivo(id:number,archivo: string) 
  {
    let nombre = archivo.split('.')[0];
    let extencion = archivo.split('.').pop();
    let json={
      'idIniciativa':id,
      'nombreArchivo':nombre,
      'extensionArchivo':extencion
    }
    return this.http.post(`${this.urlAPI2}Archivo/descargarArchivoIniciativa`,json,{responseType: 'blob' });
  }

  descargarArchivoComentarios(id:number,archivo: string, id_comentario:number) 
  {
    let json={
      'id_iniciativa':id,
      'id_comentario':id_comentario,
      'nombre_archivoComentario':archivo
    }
    return this.http.post(`${this.urlAPI2}Archivo/descargarArchivoComentario`,json,{responseType: 'blob' });
    //return this.http.get(`${this.urlAPI2}Archivo/descargarArchivo/${id}/${nombre}/${extencion}`,{ responseType: 'blob' });
  }

  // Envio de iniciativas
  enviarIniciativa(id:number, email:string,rol:number) 
  {
    let valores={
      'id_iniciativa':id,
      'email': email,
      'rolUserlogin':rol
    }
    return this.http.post(`${this.urlAPI2}IniciativaNueva/enviarIniciativa`, valores);
  }

  //Método para la priorizacion de área
  envioPriorizacionArea(valores:any)
  {
    /*var myJSON = JSON.stringify(priorizar);
    let valores={
      userlogin: datos,
      json_priorización:myJSON
    }*/
    return this.http.post(`${this.urlAPI2}IniciativaNueva/priorizacionDirectorArea`, valores);
  }

  //Método para la priorizacion de área
  envioPriorizacionGral(valores:any)
  {
    return this.http.post(`${this.urlAPI2}IniciativaNueva/priorizacionDirectorGeneral`, valores);
  }

  
  //Método para la priorizacion subsecretario
  envioPriorizacionSubsecretario(valores:any)
  {
    return this.http.post(`${this.urlAPI2}IniciativaNueva/priorizacionSubsecretario`, valores);
  }

  solicitudEnvioFueraPeriodo(datos:any)
  {
    return this.http.post(`${this.urlAPI2}IniciativaNueva/solicitarAutorizacionEnvio`, datos);
  }

  //Método para solicitar cancelacion de iniciativa
  solicitudCancelacion(datos:any)
  {
    return this.http.post(`${this.urlAPI2}IniciativaNueva/solicitarCancelacion`, datos);
  }

   //Método para mostrar el historial de las iniciativas
   contactosIniciativa(id_iniciativa:number)
   {
     return this.http.post(`${this.urlAPI2}EquipoTrabajo/GetContactos/${id_iniciativa}`,'');
   }

   //Método para solicitar cancelacion de iniciativa
   agregarComentarios(datos:any)
  {
    return this.http.post(`${this.urlAPI2}IniciativaNueva/agregarComentario`, datos);
  }

   //Método para mostrar el historial de las iniciativas
   comentariosIniciativa(id_iniciativa:number, email:string,idRol:number)
   {
    let valores={
      id_iniciativa:id_iniciativa,
      email_usuarioComentario: email,
      id_rol:idRol
    }
     return this.http.post(`${this.urlAPI2}IniciativaNueva/getComentarios`,valores);
   }

    //Método para mostrar el historial de las iniciativas
    getListSubsecretarias()
    {
      return this.http.post(`${this.urlAPI2}/subsecretaria/getListSubsecretarias`,'');
    }

    //Método para mostrar los periodos de envio
    getListPeriodosEnvio()
    {
      return this.http.post(`${this.urlAPI2}/Periodo/getListPeriodoEnvio`,'');
    }

    //Método para eliminar el periodo de envio
    deletePeriodoEnvio(id_periodo:number)
  {
    return this.http.post(`${this.urlAPI2}Periodo/deletePeriodoEnvio/${id_periodo}`,'');
  }

   //Método para agregar el periodo de envio
   addPeriodoEnvio(form:any)
   {
    let valores={
      fechaInicio_periodoEnvio:form.controls['fechaInicio_periodoEnvio'].value,
      fechaTermino_periodoEnvio:form.controls['fechaTermino_periodoEnvio'].value
    }
     return this.http.post(`${this.urlAPI2}Periodo/insertPeriodoEnvio`,valores);
   }

   //Método para editar el periodo de envio
   updatePeriodoEnvio(id_periodo:number,form:any)
   {
    let valores={
      id_periodoEnvio:id_periodo,
      fechaInicio_periodoEnvio:form.controls['fechaInicio_periodoEnvio'].value,
      fechaTermino_periodoEnvio:form.controls['fechaTermino_periodoEnvio'].value
    }
     return this.http.post(`${this.urlAPI2}Periodo/updatePeriodoEnvio`,valores);
   }

   //Método para obtener un periodo de envio por id
   getPeriodoEnviobyId(id_periodo:number)
   {
     return this.http.post(`${this.urlAPI2}Periodo/getPeriodoEnvioById/${id_periodo}`,'');
   }

   //Método para mostrar los motivos
   getListMotivos()
   {
     return this.http.post(`${this.urlAPI2}/motivos/getListMotivos`,'');
   }

   //Método para agregar los motivos
   addMotivos(form:any)
   {
    let valores={
      descripcion_motivo:form.controls['descripcion_motivo'].value,
      id_tipoMotivo:form.controls['id_tipoMotivo'].value
    }
     return this.http.post(`${this.urlAPI2}motivos/insertMotivos`,valores);
   }

  //Método para eliminar el motivos
  deleteMotivo(id_motivo:number)
  {
    return this.http.post(`${this.urlAPI2}motivos/deleteMotivos/${id_motivo}`,'');
  }

   //Método para obtener los tipos de motivos
   getTipoMotivos()
   {
    return this.http.post(`${this.urlAPI2}/motivos/getListTipoMotivo`,'');

   }

   //Método para editar el motivos
   updateMotivo(id_motivo:number,form:any)
   {
    let valores={
      id_motivo:id_motivo,
      descripcion_motivo:form.controls['descripcion_motivo'].value,
      id_tipoMotivo:form.controls['id_tipoMotivo'].value
    }
     return this.http.post(`${this.urlAPI2}motivos/updateMotivos`,valores);
   }

     //Método para obtener un motivo de envio por id
     getMotivobyId(id_motivo:number)
     {
       return this.http.post(`${this.urlAPI2}motivos/getMotivoById/${id_motivo}`,'');
     }

     //Método para agregar el nombre de la subsecretaria
  addSubsecretaria(nombre:string)
  {
    let valores={
      nombre_subsecretariaSap:nombre,
    }
     return this.http.post(`${this.urlAPI2}subsecretaria/InsertSubsecretaria`,valores);
   }

   //Método para eliminar la subsecretaria
   deleteSubsecretaria(id_subsecretaria:number)
  {
    return this.http.post(`${this.urlAPI2}subsecretaria/deleteSubsecretaria/${id_subsecretaria}`,'');
  }

  //Método para editar subsecretaria
  updateSubsecretaria(id:number,nombre:string)
  {
   let valores={
    id_subsecretariaSap:id,
    nombre_subsecretariaSap:nombre
   }
    return this.http.post(`${this.urlAPI2}subsecretaria/updateSubsecretaria`,valores);
  }

  //Método para obtener un motivo de envio por id
  getSubsecretariabyId(id_subsecretaria:number)
  {
    return this.http.post(`${this.urlAPI2}subsecretaria/getSubsecretariaById/${id_subsecretaria}`,'');
  }

  
   //Método para mostrar las direcciones generales con subsecretarias
   getListDireccionesGral()
   {
     return this.http.post(`${this.urlAPI2}/dirGeneralSAP/getListDireccionGeneralSAP`,'');
   }

   //Método para mostrar las direcciones generales sin subsecretarias
   getListDireccionesGralSinSub()
   {
     return this.http.post(`${this.urlAPI2}/dirGeneralSAP/getDirGeneralSinSubsecretaria`,'');
   }


  //Método para agregar una nueva direccion gral
  addDireccionGral(nombre:string)
  {
    let valores={
      nombre_dirgralSap:nombre,
    }
     return this.http.post(`${this.urlAPI2}dirGeneralSAP/insertDireccionGeneralSAP`,valores);
   }

   //Método para modificar la direccion gral.
   updateDireccionGral(id:number,nombre:string)
  {
   let valores={
    id_dirgralSap:id,
    nombre_dirgralSap:nombre
   }
    return this.http.post(`${this.urlAPI2}dirGeneralSAP/updateDireccionGeneralSAP`,valores);
  }

  //Método para obtener una direccion gral por id
  getDirGralById(id:number)
  {
    return this.http.post(`${this.urlAPI2}dirGeneralSAP/getDireccionGeneralById/${id}`,'');
  }

  
   //Método para eliminar la subsecretaria
   deleteDirGral(id:number)
  {
    return this.http.post(`${this.urlAPI2}/dirGeneralSAP/deleteDireccionGeneralSAP/${id}`,'');
  }

  
   //Método para mostrar las direcciones de area
   getListDireccionesArea()
   {
     return this.http.post(`${this.urlAPI2}/dirAreaSAP/getListDireccioAreaSAP`,'');
   }

   //Método para agregar una nueva direccion gral
  addDireccionArea(nombre:string)
  {
    let valores={
      nombre_areaSap:nombre,
    }
     return this.http.post(`${this.urlAPI2}/dirAreaSAP/InsertDireccionAreaSAP`,valores);
   }

   //Método para modificar la direccion gral.
   updateDireccionArea(id:number,nombre:string)
  {
   let valores={
    id_areaSap:id,
    nombre_areaSap:nombre
   }
    return this.http.post(`${this.urlAPI2}/dirAreaSAP/updateDireccionAreaSAP`,valores);
  }


  //Método para obtener una direccion de area por id
  getDirAreaById(id:number)
  {
    return this.http.post(`${this.urlAPI2}/dirAreaSAP/getDireccioAreaSAPById/${id}`,'');
  }

  //Método para eliminar la subsecretaria
  deleteDirArea(id:number)
  {
    return this.http.post(`${this.urlAPI2}/dirAreaSAP/deleteDireccionAreaSAP/${id}`,'');
  }


  //Método para eliminar el proceso
  deleteProcesoCosteo(id:number)
  {
    return this.http.post(`${this.urlAPI2}/costeo/deleteCosteoByProceso/${id}`,'');
  }
   
  //Método para obtener las direccion gral. por subsecretaria
  getDirGralBySubsecretaria(id:number)
  {
    return this.http.post(`${this.urlAPI2}/dirGeneralSAP/getListDirGralBySubsecretaria/${id}`,'');
  }

  //Metodo para guardar/modificar subsecretaria con dir.gral
  insertUpdateSubsDirGral(idDirGral:number, idSubse:number){
    return this.http.post(`${this.urlAPI2}/dirGeneralSAP/updateSubsecretariaDirGeneral/${idDirGral}/${idSubse}`,'');
  }

  //Método para eliminar la relacion subse-dirGral
  deleteSubsDirGral(id:number)
  {
    return this.http.post(`${this.urlAPI2}/dirGeneralSAP/deleteRelacionSubsecretaria/${id}`,'');
  }

   //Método para mostrar las direcciones de area sin gral.
   getListDireccionAreaSinGral()
   {
     return this.http.post(`${this.urlAPI2}/dirAreaSAP/getListDirAreaSinDirGeneral`,'');
   }

   //Método para obtener las direccion area. por gral.
  getDirAreaByGral(id:number)
  {
    return this.http.post(`${this.urlAPI2}/dirAreaSAP/getListDirAreaByIdDirGeneral/${id}`,'');
  }

  //Metodo para guardar/modificar dir gral. con dir. area
  insertUpdateDirGralArea(idDirGral:number, idDirArea:number){
    return this.http.post(`${this.urlAPI2}/dirAreaSAP/updateDirGeneralDirArea/${idDirArea}/${idDirGral}`,'');
  }

  //Método para eliminar la relacion dirGral-Area
  deleteDirGralArea(id:number)
  {
    return this.http.post(`${this.urlAPI2}/dirAreaSAP/deleteRelacionDirGeneral/${id}`,'');
  }
  
  
  //Método para agregar procedimiento
  UpdateAplicacionIniciativa(data:any)
  {
    return this.http.post(`${this.urlAPI2}/IniciativaNueva/updateAreaAplicacion`,data);
  }

  //Método para cargar la lista de anlista de TI
  getListAnalistasTI(){
    return this.http.post(`${this.urlAPI2}/users/getListAnalistasTi`,'');
  }

    //Método para cargar la lista de gestores de cambios
    getGestoresCambio(){
      return this.http.get(`${this.urlAPI2}/users/getListGestorCambios`);
    }

  z
  //Método para cargar la lista de lideres
  getListLideres(){
    return this.http.post(`${this.urlAPI2}/users/getListLideres`,'');
  }

  //Método para cargar la lista de Gestor de Cambios y Analista TI
  /*getListGestorAnaliTI(valores: any) {
    return this.http.post(`${this.urlAPI2}v2/users/getListAnalistasTi`, valores).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Error en la petición:', error);
        return throwError(error);
      })
    );
  }*/
  //Lista de gestor de cambios
  getListGestorCambios(){
    return this.http.get(`${this.urlAPI2}/users/getListGestorCambios`);
  }

  //Lista de analista de TI
  getListAnalistaTI(){
    return this.http.get(`${this.urlAPI2}/users/getListAnalistasTi`);
  }
  //Método para cargar la lista de desarrolladores
  getListDesarrolladores(){
    return this.http.post(`${this.urlAPI2}/users/getListDesarrolladores`,'');
  }

  
  insertIntegranteEquipo(valores:any){
    return this.http.post(`${this.urlAPI2}/EquipoTrabajo/InsertIntegranteEquipo/`,valores);
  }

  insertIntegranteEquipov2(valores:any){
    return this.http.post(`${this.urlAPI2}/EquipoTrabajo/InsertIntegranteEquipo/`,valores);
  }

  confirmarEquipoTrabajo(valores:any){
    return this.http.post(`${this.urlAPI2}/EquipoTrabajo/ConfirmarEquipoTrabajo/`,valores);
  }

  
  
  deleteAnalista(valores:any){
    return this.http.post(`${this.urlAPI2}/EquipoTrabajo/deleteIntegranteEquipo/`,valores);
  }

  
  //Método para cargar la lista de lideres
  getEquipoTrabajo(id:number){
    return this.http.post(`${this.urlAPI2}EquipoTrabajo/getEquipoTrabajo/${id}`,'');
  }

  //Metodo para listar los estatus de iniciativa
  getListCambioEstatus(){
    return this.http.post(`${this.urlAPI2}Estatus/getCambioEstatus/`,'');
  }

  
  //Metodo para guardar  el tipo de estatus de iniciativa
  guardarCambioEstatus(valores:any){
    return this.http.post(`${this.urlAPI2}IniciativaNueva/cambiarEstatus/`,valores);
  }

  //Metodo lista motivos cancelacion
  getListMotivosCancelacion(){
    return this.http.post(`${this.urlAPI2}motivos/getMotivosCancelacion/`,'');
  }

  //Metodo lista motivos suspencion
  getListMotivosSuspencion(){
    return this.http.post(`${this.urlAPI2}motivos/getMotivosSuspension/`,'');
  }

  //Metodo lista motivos Rechazo
  getListMotivosRechazo(){
    return this.http.post(`${this.urlAPI2}motivos/getMotivosRechazo/`,'');
  }

  //Método para obtener solicitudes de cancelacion
  getSolicitudCancelacion(id:number){
    return this.http.post(`${this.urlAPI2}/IniciativaNueva/GetSolicitudById/${id}`,'');
  }

  //Metodo para rechazar solicitud de cancelacion
  rechazoSolicitudCancelacion(valores:any){
    return this.http.post(`${this.urlAPI2}IniciativaNueva/rechazarSolicitudCancelacion/`,valores);

  }

  
  //Metodo para autorizar solicitud de cancelacion
  autorizacionSolicitudCancelacion(valores:any){
    return this.http.post(`${this.urlAPI2}IniciativaNueva/autorizarSolicitudCancelacion/`,valores);
  }

  
  //Metodo para autorizar solicitud de envio
  autorizacionSolicitudEnvio(valores:any){
    return this.http.post(`${this.urlAPI2}IniciativaNueva/autorizarSolicitudEnvio/`,valores);
  }

  
  //Metodo para rechazar solicitud de envio
  rechazoSolicitudEnvio(valores:any){
    return this.http.post(`${this.urlAPI2}IniciativaNueva/rechazarSolicitudEnvio/`,valores);
  }

  
  //Metodo para visualizar los comentarios
  marcarVistoComentarios(valores:any){
    return this.http.post(`${this.urlAPI2}IniciativaNueva/marcarVistoComentarios/`,valores);
  }

  //Metodo para obtener la subsecretaaria dependiendo a la dir. gral.
  getSubsecretariaByIdGeneral(id:number){
    return this.http.post(`${this.urlAPI2}subsecretaria/getSubsecretariaByIdGeneral/${id}`,'');
  }

  //Método para validar si es periodo de priorizacion o no
  getPeriodoPriorizacion(id:number){
    return this.http.post(`${this.urlAPI2}Periodo/getAccionPriorizacion/${id}`,'');
  }

  
  updateArchivoProcesoActual(valores:any){
    return this.http.post(`${this.urlAPI2}IniciativaNueva/updateArchivoProcesoActual`,valores);
  }

   
  updateArchivoProcesoPropuesto(valores:any){
    return this.http.post(`${this.urlAPI2}IniciativaNueva/updateArchivoProcesoPropuesto`,valores);
  }

     
  updateArchivoAnexos(valores:any){
    return this.http.post(`${this.urlAPI2}IniciativaNueva/updateArchivoAnexos`,valores);
  }

  descargarExcelPriorizacion(json:any){
    return this.http.post(`${this.urlAPI2}IniciativaNueva/descargarExcelPriorizacion`,json,{responseType: 'blob' });
  }

  
    //Método para mostrar el tipo de iniciativas
    getListTipoIniciativas()
    {
      return this.http.get(`${this.urlAPI2}tipoIniciativa/getListTipoIniciativas`);
    }

    //get enlaces
    getEnlacesList(body)
    {
      return this.http.post(`${this.urlAPI2}cambioEnlace/getProyectosCambios`,body);
    }

    cambioRequerimientos(body)
    {
      return this.http.post(`${this.urlAPI2}IniciativaNueva/cambioRequerimiento`,body);
    }

    
    //Método para mostrar todas las aplicaciones
    getListAplicaciones()
    {
      return this.http.get(`${this.urlAPI2}IniciativaNueva/getAplicaciones`);
    }

    
    //Método para mostrar todos los enlaces de iniciativas
    getListEnlaces()
    {
      return this.http.get(`${this.urlAPI2}users/getEnlaces`);
    }

     //Iniciativa por folio
     getEnlaceByFolio(folio:number)
     {
       return this.http.get(`${this.urlAPI2}cambioEnlace/getEnlaceByFolio?folio=${folio}`);
     }


     //Combo de enlaces nuevos
     getEnlacesReemplazo(idDirGral:number, idTipoIniciativa:number)
     {
       return this.http.get(`${this.urlAPI2}cambioEnlace/getEnlacesReemplazo?direccionGeneral=${idDirGral}&tipoIniciativa=${idTipoIniciativa}`);
     }

     updateEnlaceIniciativa(valores:any){
      return this.http.put(`${this.urlAPI2}cambioEnlace/updateEnlaceIniciativa`,valores);
      }

    insertArea(area:string)
    {
      let valores={
      'nombre_area':area
      }
    return this.http.post(`${this.urlAPI2}area/insertArea`,valores);
  }

  //Metodo para eliminar las areas 
  deleteArea(id:number)
  {
    return this.http.delete(`${this.urlAPI2}area/deleteArea?id_area=${id}`);
  }

  
  updateArea(valores:any){
    return this.http.put(`${this.urlAPI2}area/updateArea`,valores);
    }

  //Area por id
  getAreaById(id:number)
  {
      return this.http.get(`${this.urlAPI2}area/getAreaById?id_area=${id}`);
  }

  insertApp(app:string)
  {
    let valores={
    'nombre_aplicacion':app
    }
     return this.http.post(`${this.urlAPI2}aplicacion/insertAplicacion`,valores);
  }

  //Metodo para eliminar las aplicaciones
  deleteApp(id:number)
  {
    return this.http.delete(`${this.urlAPI2}aplicacion/deleteAplicacion?id_aplicacion=${id}`);
  }

  updateAplicacion(valores:any){
    return this.http.put(`${this.urlAPI2}aplicacion/updateAplicacion`,valores);
    }

  //Area por id
  getAppById(id:number)
  {
      return this.http.get(`${this.urlAPI2}aplicacion/getAplicacionById?id_aplicacion=${id}`);
  }

  //Método de list aplicación sin area 
  getListAplicacionSinArea()
  {
      return this.http.get(`${this.urlAPI2}aplicacion/getListAplicacionSinArea`);
  }

  //Método de list aplicación sin area 
  getAplicacionesByArea(id:number)
  {
      return this.http.post(`${this.urlAPI2}IniciativaNueva/getAplicacionesByArea/${id}`,'');
  }

   //Metodo para guardar/modificar area-app
   insertUpdateAreaApp(app:number, area:number){
    return this.http.put(`${this.urlAPI2}aplicacion/updateAreaAplicacion?id_aplicacion=${app}&id_area=${area}`,'');
  }

   //Método para eliminar la relacion subse-dirGral
   deleteAreaApp(id:number)
   {
     return this.http.delete(`${this.urlAPI2}aplicacion/deleteRelacionAplicacion?id_aplicacion=${id}`);
   }

   //Método para subir el archivo de solicitud fuera de envio de periodo
   subirArchivoSolicitudEnvio(archivo: any,nombre:string,id_iniciativa:number)
   {
    let extencion;
    let ext;
    ext = nombre.split('.');
    extencion=ext[ext.length-1];

     let datosArchivo={
       idIniciativa:id_iniciativa,
       nombreArchivo:nombre,
       extensionArchivo:'.'+extencion,
       contenido:archivo
     }
     return this.http.post(`${this.urlAPI2}Archivo/subirEvidenciaJustifiar`,datosArchivo)
   }


   //Método para descargar archivo de solicitud de envio
   descargarArchivoSolicitudEnvio(id:number) 
   {
     let json={
       'idIniciativa':id
     }
     return this.http.post(`${this.urlAPI2}Archivo/obtenerEvidenciaJustificar`,json);
   }

   cambiarAtencion(obj)
   {
     return this.http.post(`${this.urlAPI2}IniciativaNueva/rapidaAtencion`,obj);
   }

   evaluacionTecnica(body){
    return this.http.post(`${this.urlAPI2}IniciativaNueva/evaluacionTecnica`,body);
   }

   disenoFinalizada(body){
    return this.http.post(`${this.urlAPI2}IniciativaNueva/disenoFinalizado`,body);
   }

   //Reportes
  obtenerIniciativasReporte(paginado: Paginado) 
  {
    return this.http.post(`${this.urlAPI2}IniciativaNueva/getReporteGrid`,paginado);
  }

   //Método para descargar archivo de reporte
   descargarArchivoReporte(paginado: Paginado) 
   {
     return this.http.post(`${this.urlAPI2}IniciativaNueva/getReporte`,paginado,{responseType: 'blob' });
   } 

   /**Servicio portal por tipo de modulo*/ 
   getDocumentoFormatoAyuda(id_tipoIniciativa:number): Observable<Blob> {
    return this.http.post(
      `${this.urlAPI2}Archivo/descargarFormatoAyuda`,
      {id_tipoIniciativa:id_tipoIniciativa},
      {responseType:'blob'}
    ).pipe(retry(3));
  }
}
